<template>
    <div class="bet-game"
    > 
        <modal :hideModal="!hideModal" class="lightbox" :circleColor="colors.primary" :modalMessage="$t('views.betGameNew.modal') + (gameInfo.length + 1) + '/4'"></modal>
        <navbar :currentScore="16000"></navbar>
        <div class="bet-game-container">
            <bet-alert :index="indexGame" v-if="bet" @sendBet="sendBet" @deleteBet="deleteBet" :bet="bet"></bet-alert>
            <div v-if="!bet" class="bet-infos"
                :style="{
                    'background':`url(../../img/bet/background-${colors.theme}.png), linear-gradient(180deg, ${colors[colors.theme].from} 0%,  ${colors[colors.theme].to} 100%)`
                }"
            >
                <bet-index :index="indexGame"></bet-index>
                <bet-options @setBet="showAlert"></bet-options>
            </div>
        </div>
    </div>
</template>
<script>
import BetIndex from '../components/bet/BetIndex.vue'
import BetOptions from '../components/bet/BetOptions.vue'
import BetAlert from '../components/bet/BetAlert.vue'
import Navbar from '../components/shared/header/Navbar'
import { Bus } from '../event-bus.js'
import Modal from '../components/shared/default/Modal'
export default {
    components : {
        BetIndex,
        BetOptions,
        Navbar,
        BetAlert,
        Modal
    },
    data(){
        return{
            gameInfo: this.$store.getters.getSoloGame,
            hideModal: false,
            bet : '',
            colors: {}
        }
    },
    beforeMount(){
        Bus.$on('nextSoloGame', this.nextSoloGame)
        Bus.$on('saveSoloGame', this.saveSoloGame)
        let soloGame = this.$store.getters.getSoloGame
        let gameSetId = localStorage.getItem('gameSetId')
        let self = this
        // console.log("this.gameInfo.length : ", this.gameInfo.length )
        if(this.gameInfo.length >= 4 && this.gameInfo[3].status != 'inprogress'){
            // this.$store.commit('resetSoloGameState')
            this.$router.push({ path: 'report/generate' })
            return
        }
    },
    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    destroyed(){
        Bus.$off('nextSoloGame')
    },
    computed:{
        indexGame(){
            return this.gameInfo.length
        }
    },
    methods : {
        showAlert(bet){
            this.bet = bet
        },
        saveSoloGame(soloGames){
            this.gameInfo = soloGames
        },
        selectBet(betArg){
            let bets = this.bets
            bets.forEach(function(bet){
                bet.status = 'lock'
            })
            betArg.status = 'selected'
            betArg.answer = 1 // buscar o numero da questao de algum lugar
            this.statusButton = 'enabled'
        },
        sendBet(){
            this.$store.dispatch('setBet', this.bet.bet)
            this.hideModal = true
        },
        deleteBet(){
            this.bet = null
        },
        nextSoloGame(){
            this.$router.push('/solo-game')
        }
    }
    
}
</script>
<style lang="scss" scoped>
    .bet-game{
        height: 100%;
        .bet-game-container{
            height: calc(100% - 55px);

            .bet-infos{
                height: 100%;
                background-size: cover !important;
                padding: 0 1rem;
                overflow-y: auto;
            }
        }
    }
    @media screen and (min-width: 768px) {
        .bet-game{
            .bet-game-container{
                .bet-infos{
                    display: grid;
                    grid-template-rows: 40% 60%;
                }
            }
        }
    }
</style>
